import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from 'App';
import {
  Container,
  Section,
  Logo,
  Title,
  Tabs,
  Tab,
  TabLabel,
  UserProfile,
  Avatar,
  BackDrop,
  Popover,
  Box,
  Label,
  CoinsContainer,
  CoinsIcon,
  LogoutContainer,
  LogoutIcon,
} from './Styles';
import { useAuth } from 'Auth';

const NavBar = () => {
  const navigate = useNavigate();
  const { signout } = useAuth();
  const { setStoreType, state } = useApp();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { storeType, user } = state;
  const { picture, fNe: firstName, lNe: lastName, nie: nickName, lel: level, cBe } = user;

  const handleStoreTypeChanged = type => {
    setStoreType(type);
    navigate('/', { replace: true });
  };

  const tabs = [
    { key: 'E', label: 'Special Price' },
    { key: 'BP', label: 'Store' },
  ];

  const togglePopover = () => setIsPopoverOpen(prev => !prev);

  return (
    <Container>
      <Section>
        <Logo />
        <Title>Lord Of The Board Store</Title>
        <Tabs>
          {tabs.map(({ key, label }) => (
            <Tab key={key} onClick={() => handleStoreTypeChanged(key)}>
              <TabLabel $isActive={key === storeType}>{label}</TabLabel>
            </Tab>
          ))}
        </Tabs>
      </Section>
      <UserProfile>
        <Avatar onClick={togglePopover} $avatar={picture?.data.url} />
        {isPopoverOpen && (
          <>
            <BackDrop onClick={togglePopover} />
            <Popover $isPopoverOpen={isPopoverOpen}>
              <Box>
                <Label $isBreakWord={(firstName + lastName).length > 12}>
                  {firstName ? `${firstName} ${lastName}` : nickName}
                </Label>
                <Label>Level {level}</Label>
                <CoinsContainer>
                  <CoinsIcon />
                  <Label>{cBe.toLocaleString()}</Label>
                </CoinsContainer>
              </Box>
              <LogoutContainer onClick={signout}>
                Logout
                <LogoutIcon />
              </LogoutContainer>
            </Popover>
          </>
        )}
      </UserProfile>
    </Container>
  );
};

export default NavBar;
